import { render, staticRenderFns } from "./HazardPopover.vue?vue&type=template&id=4f395a58&scoped=true"
import script from "./HazardPopover.vue?vue&type=script&lang=js"
export * from "./HazardPopover.vue?vue&type=script&lang=js"
import style0 from "./HazardPopover.vue?vue&type=style&index=0&id=4f395a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f395a58",
  null
  
)

export default component.exports